import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=714f8364&scoped=true&"
import script from "./AddressBook.vue?vue&type=script&lang=js&"
export * from "./AddressBook.vue?vue&type=script&lang=js&"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=714f8364&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f8364",
  null
  
)

export default component.exports